import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'tableNumberLabel',
  initialState: null as string | null,
  reducers: {
    setTableNumberLabel(state, action: PayloadAction<string | null>) {
      return action.payload || null;
    },
  },
});

export const { setTableNumberLabel } = slice.actions;

export default slice.reducer;
